// Figma: no frame provided yet — built using the established design system per the
// "extrapolate" decision.
// LOGIC PORTED from LC2's EngagementFinancialUnlocks.js (commons/components/HomeTabs/
// Engagement/): same shape ({title, items: [{metric, label}], data: {"YYYY-MM": count}}),
// same "render nothing when both items and data are empty" behavior.
// SIMPLIFIED: LC2 rendered a recharts ComposedChart (line+area) of monthly unlock counts.
// recharts isn't a dependency of this app (see rules re: not adding a charting lib unless
// needed) and no other ported tab needs one yet, so the trend is summarized as a plain
// "latest month" stat instead of the chart — flagged as a gap if the trend visual matters.
import React, {useMemo} from 'react';
import {Box, Stack, Typography} from '@mui/material';
import {tokens} from '../../../themes/ThemeCustomization';

const EngagementFinancialUnlocks = ({financials = {}}) => {
    const items = Array.isArray(financials.items) ? financials.items : [];
    const monthlyData = financials.data && typeof financials.data === 'object' ? financials.data : {};
    const months = Object.keys(monthlyData);

    const latestMonthLabel = useMemo(() => {
        if (months.length === 0) return null;
        const sortedKeys = [...months].sort();
        const lastKey = sortedKeys[sortedKeys.length - 1];
        const [year, month] = lastKey.split('-').map(Number);
        const date = new Date(year, (month || 1) - 1, 1);
        const label = date.toLocaleDateString('en-US', {year: '2-digit', month: 'short'});
        return {label, value: Number(monthlyData[lastKey]).toFixed(0)};
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(monthlyData)]);

    if (items.length === 0 && months.length === 0) return null;

    return (
        <Box sx={{border: `1px solid ${tokens.color.neutral200}`, borderRadius: '6px', backgroundColor: tokens.color.white, p: 2}}>
            <Stack spacing={0.5} sx={{mb: 2}}>
                <Typography variant="subtitle1" fontWeight={600}>
                    {financials.title ?? 'Financial Unlocks'}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    Track resident engagement with Stake features.
                </Typography>
            </Stack>
            <Stack direction="row" spacing={1.5} sx={{mb: months.length > 0 ? 2 : 0}}>
                {items.map((entry, index) => (
                    <Box key={index} sx={{flex: 1, border: `1px solid ${tokens.color.neutral200}`, borderRadius: '6px', p: 2}}>
                        <Typography variant="subtitle1" fontWeight={600}>
                            {entry.metric}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {entry.label}
                        </Typography>
                    </Box>
                ))}
            </Stack>
            {months.length > 0 && (
                <Box sx={{border: `1px solid ${tokens.color.neutral200}`, borderRadius: '6px', p: 2}}>
                    {latestMonthLabel ? (
                        <Typography variant="body2" color="text.secondary">
                            {latestMonthLabel.value} unlocks in {latestMonthLabel.label} (trend chart not ported this pass — see file
                            header comment)
                        </Typography>
                    ) : (
                        <Typography variant="body2" color="text.secondary">
                            Data collection in process.
                        </Typography>
                    )}
                </Box>
            )}
        </Box>
    );
};

export default EngagementFinancialUnlocks;
